import { render, staticRenderFns } from "./kindChooseViewktypevipSeventh.vue?vue&type=template&id=b5bb8252&scoped=true"
import script from "./kindChooseViewktypevipSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewktypevipSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewktypevipSeventh.vue?vue&type=style&index=0&id=b5bb8252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb8252",
  null
  
)

export default component.exports